import moment from "moment-timezone";

export const getGasDay = (): Date => {
  const spainHour = moment().tz('Europe/Madrid').hour();
  return spainHour < 6 ? moment().subtract(1, 'days').toDate() : moment().toDate();
};

export const calculateGasDay = (date: Date): Date => {
  const spainHour = moment().tz('Europe/Madrid').hour();
  return spainHour < 6 ? moment(date).subtract(1, 'days').toDate() : date;
};
